import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ShareIcon from '@wix/da-ds/pkg/Icons/24x24/Share';
import { DesktopDeviationSharePopup } from '../../../SharePopup';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
const ShareButton = ({ deviation, onClick })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t('actionbar.share'),
        renderPopover: ()=>/*#__PURE__*/ React.createElement(DesktopDeviationSharePopup, {
                deviation: deviation
            })
    }, /*#__PURE__*/ React.createElement(ActionBarToggleButton, {
        icon: ShareIcon,
        biData: BiData({
            evid: 355,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            deviationid: deviation.deviationId
        }),
        onClick: ()=>{
            if (!isMobile) {
                return;
            }
            onClick(deviation);
        },
        "data-hook": BiDataHook.DEVIATION_SHARE_BUTTON
    }));
};
ShareButton.displayName = 'ShareButton';
export default ShareButton;
